import { Pages } from 'modules/navigation/domain/enums/pages';
import { OrganizerForm } from 'modules/organizer/ui/components/organizer-form';
import { SkeletonOrganizerForm } from 'modules/organizer/ui/components/organizer-form/skeleton-organizer-form';
import { useProfileForm } from 'modules/settings/ui/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import UDAsyncContent from 'ud-ui/components/async-content';
import UDButton from 'ud-ui/components/button';
import StubSupportLink from 'ud-ui/components/stubs/components/stub-support-link/stub-support-link';
import UDText from 'ud-ui/components/text';

/**
 * Вкладка правит уже существующую организацию и никогда её не создаёт: форма без `id`
 * уходила в `upsertTournament` как создание и заводила пользователю вторую организацию.
 * Поэтому веток четыре, а не одна форма: правка, загрузка, сбой загрузки и «организации
 * нет» со ссылкой на страницу создания.
 */
function Profile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { initialValues, isSaving, state, refetch, handleSubmit } = useProfileForm();

  return (
    <UDAsyncContent
      state={state}
      loading={<SkeletonOrganizerForm />}
      error={
        <div className="flex flex-col items-center gap-4 py-10">
          <UDText type="subhead" className="text-inkSecondary text-center">
            {t('settings.profile.loadError')}
          </UDText>
          <UDButton variant="secondary" type="button" onClick={refetch}>
            {t('settings.profile.retry')}
          </UDButton>
        </div>
      }
      empty={
        <div className="flex flex-col items-center gap-4 py-10">
          <UDText type="subhead" className="text-inkSecondary text-center">
            {t('settings.profile.noOrganizer')}
          </UDText>
          {/*
            Пустая ветка означает «бэкенд не вернул ни одной организации», а не «организации
            точно нет»: инцидент 07.09.2026 начался ровно с такого ответа у пользователя,
            организация у которого была. Поэтому перед кнопкой стоит предупреждение —
            создавать вторую организацию в этом случае нельзя.
          */}
          <UDText type="footnote" className="text-inkMuted max-w-md text-center">
            {t('settings.profile.noOrganizerWarning')}
          </UDText>
          <StubSupportLink className="text-center" />
          <UDButton variant="primary" type="button" onClick={() => navigate(Pages.ORGANIZER.CREATE)}>
            {t('settings.profile.createOrganizer')}
          </UDButton>
        </div>
      }
    >
      <OrganizerForm isLoading={isSaving} initialValues={initialValues} onSubmit={handleSubmit} />
    </UDAsyncContent>
  );
}

export default Profile;
